<template>
  <el-header class="lx-top-container-header lx-bg-color-blue">
    <div class="lx-left-nav">
      <div style="cursor: pointer; margin-right: 20px;"
           @click="$router.push({ name: user.home })">
        <img src="../../assets/logo.png"
             style="vertical-align: middle;">
        <span style="margin-left: 10px; font-size: 20px; color: #fff; vertical-align: middle;">天天乐学实训教学系统</span>
      </div>
      <!--<el-menu :default-active="$route.link"-->
               <!--background-color="#5E93F6"-->
               <!--text-color="#FFF"-->
               <!--active-text-color="#FFF"-->
               <!--mode="horizontal"-->
               <!--router>-->
        <!--<el-menu-item v-for="(item, index) of navs"-->
                      <!--:key="index"-->
                      <!--:index="item.link"-->
                      <!--style="font-size: 18px">{{ item.name }}</el-menu-item>-->
      <!--</el-menu>-->
      <span v-for="(nav, index) in navs" :key="index" style="padding: 20px 40px; font-size: 20px; color: #fff; cursor: pointer;" @click="jump(nav, index)" :class="{active: nowIndex=== index}">{{nav.name}}</span>
    </div>
    <div style="display: flex; align-items: center; margin-right: 20px; color: #fff; font-size: 14px;">
      <span>你好，{{ user.name }}</span>
      <span style="margin: auto 10px;">|</span>
      <i class="fa fa-sign-out"
         style="cursor: pointer; font-size: 20px; margin-right: 5px;"></i>
      <span style="cursor: pointer;"
            @click="logout">退出</span>
    </div>
  </el-header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      navs: [],
      nowIndex: 0
    }
  },
  computed: {
    ...mapState([ 'user' ])
  },
  mounted () {
    if (this.$can('view', 'tms-root-nav')) {
      this.navs = [
        { name: '教学', link: 'TeachingManager' },
        { name: '资源中心', link: 'ResourceManager' }
      ]
    }
    if (this.$can('view', 'tms-teacher-nav')) {
      this.navs = [
        { name: '教学', link: 'TeachingManager' },
        { name: '实训', link: 'TrainingManager' },
        { name: '考核', link: 'CheckManager' }
      ]
    }
    let urlActive = this.$route.path.split('/')
    switch (urlActive[2]) {
      case 'teaching': this.nowIndex = 0; break
      case 'training': this.nowIndex = 1; break
      case 'check': this.nowIndex = 2; break
      case 'resource': this.nowIndex = 1; break
      default: this.nowIndex = 0
    }
  },
  methods: {
    logout () {
      this.$confirm('注销登录, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.$xhrPost('/sso/user/logout').then(rs => {
            if (rs.code === 200) {
              this.$store.commit('user/logout')
              sessionStorage.clear()
              this.$redirectUnlogin()
            }
          })
        })
    },
    jump (nav, index) {
      this.nowIndex = index
      this.$router.push({ name: nav.link })
    }
  }
}
</script>

<style scoped>
.lx-top-container-header { width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0px; }
.active { background-color: #3A76DB; }
.lx-left-nav { margin-left: 25px; display: flex; flex-wrap: wrap; align-items: center; }
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue